var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"q-app"}},[_c('div',{style:(_vm.is_iOS_noToolBar ? { 'margin-top': '45px' } : {})},[_c('environment-banner')],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }